export default __webpack_public_path__ + "static/media/b12.4797a2ef.jpg";